import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Bot } from '../../types/chat.types';
import './BotSelector.css';

interface BotSelectorProps {
  bots: Bot[];
  selectedBotId: string | null;
  onBotSelect: (botId: string) => void;
  loading?: boolean;
  disabled?: boolean;
}

const BotSelector: React.FC<BotSelectorProps> = ({
  bots,
  selectedBotId,
  onBotSelect,
  loading = false,
  disabled = false,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="bot-selector">
        <select className="bot-selector-dropdown" disabled>
          <option>{t('botSelector.loading')}</option>
        </select>
      </div>
    );
  }

  return (
    <div className="bot-selector">
      <select
        id="bot-select"
        className="bot-selector-dropdown"
        value={selectedBotId || ''}
        onChange={(e) => onBotSelect(e.target.value)}
        disabled={disabled}
      >
        {bots.map((bot) => (
          <option key={bot.botId} value={bot.botId}>
            {bot.botName || bot.botId}
          </option>
        ))}
      </select>
    </div>
  );
};

export default BotSelector;
